import tw from 'tailwind-styled-components'
import TextareaAutosize from 'react-textarea-autosize'

type Props = {$noBgTransparent?: boolean}

/**
 * Если нужно использовать bg-transparent,
 * используй в своём компоненте bg-transparent focus:bg-transparent
 * Если использовать их здесь,
 * то не получается перетереть эти свойства в других компонентах
 * */
export const TextArea = tw(TextareaAutosize)<Props>`
  p-0
  outline-none
  resize-none
  min-h-0
  shadow-none
  focus:shadow-none
`
